import { z } from 'zod';
import { createFileRoute } from '@tanstack/react-router';
import { FindingsPane } from '@/components/health-readiness/panes';

/**
 * Health & Readiness → Findings (T-0242): the findings register, its
 * filters in the URL so a filtered view can be shared. T-0244 redraws it.
 */
const SearchSchema = z.object({
  severity: z.string().optional(),
  status: z.string().optional(),
  domain: z.string().optional(),
});

export const Route = createFileRoute('/engagements/$engagementId/health-readiness/findings')({
  validateSearch: SearchSchema,
  component: FindingsRoute,
});

function FindingsRoute() {
  const { engagementId } = Route.useParams();
  return <FindingsPane engagementId={engagementId} />;
}
